import React from 'react';
import strings from '../../values/strings/strings';

const FALLBACK = '- -';

const formatValue = (value) => {
  if (value == null || value === '') {
    return FALLBACK;
  }
  return value;
};

/**
 * Cabeçalho com dados gerais do trabalho para impressão de mapas/gráficos.
 * Renderizado apenas durante a impressão (via onBeforePrint / onAfterPrint).
 */
const MapPrintHeader = ({
  id,
  dataInicial,
  dataFinal,
  horasTrabalhadas,
  distanciaPercorrida,
  operador,
  talhao,
}) => {
  const fields = [
    { label: strings.getString('screen_monitorItem_date_initial'), value: dataInicial },
    { label: strings.getString('screen_monitorItem_date_final'), value: dataFinal },
    { label: strings.getString('screen_monitorItem_hours_work'), value: horasTrabalhadas },
    { label: strings.getString('screen_monitorItem_distance_traveled'), value: distanciaPercorrida },
    { label: strings.getString('info_operator'), value: operador },
    { label: strings.getString('unity_talhao'), value: talhao },
  ];

  return (
    <div
      style={{
        marginBottom: 16,
        padding: '12px 0',
        borderBottom: '1px solid #ccc',
        fontFamily: 'Arial, sans-serif',
        color: '#000',
      }}
    >
      {id != null && id !== '' && (
        <div
          style={{
            fontSize: 13,
            fontWeight: 700,
            marginBottom: 6,
            color: '#222',
          }}
        >
          #{id}
        </div>
      )}
      <div
        style={{
          fontSize: 14,
          fontWeight: 700,
          marginBottom: 8,
        }}
      >
        {strings.getString('screen_monitorItem_general_data')}
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '8px 16px',
          fontSize: 12,
        }}
      >
        {fields.map((field) => (
          <div key={field.label}>
            <div style={{ fontWeight: 600, color: '#444' }}>{field.label}</div>
            <div>{formatValue(field.value)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const MAP_PRINT_PAGE_STYLE = `
  @page { size: auto; margin: 12mm; }
  @media print {
    html, body, * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    .no-print { display: none !important; }
    h1, h2, h3, h4, h5, h6 {
      color: #000 !important;
    }
    .map-legend-print > div {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .map-work-border-legend,
    .map-work-border-legend span {
      color: #000 !important;
    }
  }
`;

export default MapPrintHeader;
